module.exports = __webpack_public_path__ + "static/img/app-slide-show4.0f2f2bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/app-slide-show4.png
// module id = T3xv
// module chunks = 44